import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../lib/auth';

/**
 * Route guard for the Sustainability area. Requires an authenticated session
 * (mirrors ProtectedRoute). Kept as a dedicated wrapper so sustainability-
 * specific gating (feature flags / plan entitlements) can be layered here
 * later without touching every route.
 */
export const SustainabilityRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default SustainabilityRoute;
